import { http } from "@/lib/http";
import { useToast } from "@/providers/toast.provider";
import { useMutation, useQuery } from "@tanstack/react-query";

export type Seller = {
  id: string;
  name: string;
  email: string;
  role: "ADMIN" | "USER";
  needToChangePassword: boolean;
};

/** Vendedores para o seletor do ADMIN. A rota é restrita: só busca com `enabled`. */
export function useUsers(enabled: boolean) {
  return useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const { data } = await http.get<Seller[]>("users");
      return data;
    },
    enabled,
  });
}

/** Gera a senha temporária do vendedor; ela só vem nesta resposta. */
export function useResetUserPassword() {
  const { toaster } = useToast();

  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await http.post<{ success: boolean; password: string }>(
        `users/${id}/reset-password`,
      );
      return data;
    },
    onError: (error) => {
      toaster(error?.message ?? "Algo deu errado!", "error");
    },
  });
}
